import React from 'react';
import { Modal, ModalBody, Spinner } from 'reactstrap';
import '../../assets/styles/dab.css'

interface ILoadingSpinnerProps {
	isShowModal: boolean;
	modalChange: any;
}

interface ILoadingSpinnerState {
	modal: boolean;
	backdrop: string;
}

class LoadingSpinnerModal extends React.Component<ILoadingSpinnerProps, ILoadingSpinnerState>  {
	constructor(props) {
		super(props);

		this.state = {
			modal: false,
			backdrop: "static"
		};
		this.toggle = this.toggle.bind(this);
		//this.handleOnsubmit = this.handleOnsubmit.bind(this);
	}

	componentDidMount() {
		const { isShowModal } = this.props;
		this.setState({ modal: isShowModal });
	}

	toggle(event) {
		this.setState(prevState => ({
			modal: !prevState.modal
		}));
		this.props.modalChange(false, !this.state.modal);
	}

	// TODO unsafe lifecycle method ("https://reactjs.org/blog/2018/03/27/update-on-async-rendering.html")

	/*componentWillReceiveProps(newProps) {
		const oldProps = this.props
		if (oldProps.isShowModal !== newProps.isShowModal) {
			this.setState({ modal: newProps.isShowModal })
		}
	}*/

	// instead of componentWillReceiveProps lifecycle method
	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.isShowModal !== prevState.isShowModal) {
			return ({ modal: nextProps.isShowModal })
		}
		return null
	}

	//handleOnsubmit(event) {
	//  this.toggle(true);
	//  this.props.modalChange(true, true);
	//}

	render() {
		return (
			<div className="custom-loader-spiiner testclass" >
				<Modal className="custom-loader-spiiner" isOpen={this.state.modal} toggle={this.toggle} backdrop="static" backdropClassName="test">
					<ModalBody className="custom-loader modal-loading-inner">
						<div>
							<Spinner type="grow" color="primary" />
							<Spinner type="grow" color="secondary" />
							<Spinner type="grow" color="success" />
							<Spinner type="grow" color="danger" />
							<Spinner type="grow" color="warning" />
							<Spinner type="grow" color="info" />
							<Spinner type="grow" color="light" />
							<Spinner type="grow" color="dark" />
						</div>
						<div className="modal-loading-text" id="modal-text">
							Processing...Please wait.
						</div>
					</ModalBody>
				</Modal>
			</div>
		);
	}
}

export default LoadingSpinnerModal;